import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { api } from '../config/api';
import type {
  RenderVideoBody,
  RenderVideoResult,
  VideoTemplateSpec,
} from '../types/api';

/**
 * POST /video/render → renders the MP4, uploads to GCS, persists a
 * video_runs row. On success invalidates the video-runs list query so the
 * recent-runs sidebar updates.
 */
export function useRenderVideo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: RenderVideoBody) =>
      api<RenderVideoResult>('/video/render', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['video-runs'] });
    },
  });
}

export function useVideoTemplates() {
  return useQuery({
    queryKey: ['video-templates'],
    queryFn: () =>
      api<{ templates: VideoTemplateSpec[] }>('/video/templates').then(
        (r) => r.templates,
      ),
    staleTime: 5 * 60 * 1000,
  });
}
